import {get} from 'svelte/store';
import {dyData, modal} from '../../store';
import {COOKIE_VALUE, STATE} from '../../constants';
import {getCookie} from '../getCookie';

/**
 * Set the value of the first side
 */
export const expSetRightSide = (): void => {
    if (
        get(dyData).side.sms &&
        get(dyData).firstSide === STATE.SMS &&
        Boolean(!getCookie(COOKIE_VALUE.SUBSCRIBER_PHONE))
    ) {
        modal.changeState(STATE.SMS);
    } else {
        modal.changeState(STATE.MAIN);
    }
};
